<template>
	<div class="container">
		<div class="catalog-container">
			<CatalogBreadcrumbs v-if="breadcrumbs" :navLinks="breadcrumbs" />
			<h1 class="title">{{ data?.name }}</h1>
			<CatalogCategories :async-key="'services'" />
		</div>
	</div>
</template>
<script setup lang="ts">
import CatalogCategories from '~/components/catalog/CatalogCategories.vue';
import { useCategories } from '~/composables/categories/useCategories';
const { getCategoryBySlug } = useCategories()
const { setSEOTitles } = seoHandlers()

const { t, locale } = useI18n();

const { data } = await useAsyncData('services', () => getCategoryBySlug('services'))
if (data.value?.seo_meta_data) {
	setSEOTitles({
    seoTitle: data.value?.seo_meta_data?.seo_title || '',
		seoDescription: data.value?.seo_meta_data?.seo_description || '',
		seoKeywords: data.value?.seo_meta_data?.seo_keywords || ''
	})
}

const breadcrumbs = computed(() => {
	return [
		{ name: t('interface.home'), link: '/' },
		{ name: data.value?.name ?? '', link: `/services` },
	];
});
</script>

<style lang="scss" scoped>
.catalog-container {
	display: flex;
	flex-direction: column;
	margin-top: 24px;

	.title {
		margin-top: 64px;
		margin-bottom: 32px;
		font-weight: 800;
		font-size: 40px;
		line-height: 80%;
		letter-spacing: -0.03em;
		text-align: center;
		color: #1d254a;
	}
}

@media (max-width:1023px) {

	.catalog-container {

		.title {
			margin-top: 40px;
			margin-bottom: 20px;
			font-size: 28px;
			text-align: start;
		}
	}

}
</style>